/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import styles from './workflow.module.scss'; 
import CommercialWorkFlow from './CommercialWorkflow/commercialWorkflow';
import EffortWorkFlow from './EffortWorkflow/effortWorkflow';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules'; 
import PuzzleLoader from '../../../Assets/images/svg/loading puzzle.gif';

const WorkFlow = () => {
  const [alignment, setAlignment] = useState('Commercial workflow');
  const [loading, setLoading] = useState(true);
  const { userProfile } = useContext(AuthContext);

  const permissions = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_WORKFLOW] || []
  : [];

  const hasAccess = (action) => permissions.includes(action);

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment); 
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles['workflow-outer-div']} style={{ marginTop: '30px', marginLeft: '19px', marginRight: '15px' }}>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
          <img
            src={PuzzleLoader}
            alt="Loading..."
            className="loader-gif"
            style={{ width: '100px', height: 'auto' }}
          />
        </div>
      ) : (
        <>
          <div className={styles['title']}>Deal Transition - {alignment}</div>

          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className={styles['toggle-button-group']}
          >
            <ToggleButton
              value="Commercial workflow"
              className={styles['toggle-button']}
            >
              Commercial workflow
            </ToggleButton>
            <ToggleButton
              value="Effort approval workflow"
              className={styles['toggle-button']}
            >
              Effort approval workflow
            </ToggleButton>
          </ToggleButtonGroup>
          {alignment === 'Commercial workflow' ? (
            <CommercialWorkFlow alignment={alignment} hasAccess={hasAccess}/>
          ) : (
            <EffortWorkFlow alignment={alignment} hasAccess={hasAccess}/>
          )}
        </>
      )}
    </div>
  );
};

export default WorkFlow;
